module.exports = __webpack_public_path__ + "static/img/3.b35aaca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR404A/3.jpg
// module id = Jj5g
// module chunks = 1